export const AppointmentDecisionEN = {
    "appointmentDecision": {
        "heading": {
            "addAppointment" : "Add Appointment Decision",
            "detailAppointment" : "Detail Appointment Decision",
            "updateAppointment" : "Update Appointment Decision",
            "generalInformation" : "General Information"
        },
        "label":{
            "department": "Appoint Department",
            "jobPosition" : "Appoint Position",
            "jobTitle" : "Appoint Job Title"
        },
        "placeholder":{
            "department": "Select Department",
            "jobPosition" : "Select Position",
            "jobTitle" : "Select Job Title"
        },
        "message" : {
            "department": "Please select Appoint Department",
            "jobPosition" : "Please select Appoint Position",
            "jobTitle" : "Please select Appoint Job Title"
        },
        "detail": {
            "currentDepartment": "Old Department",
            "currentJobPosition" : "Old Position",
            "currentJobTitle" : "Old Job Title",
            "appointDepartment": "Appoint Department",
            "appointJobPosition" : "Appoint Position",
            "appointJobTitle" : "Appoint Job Title",
        }
    }
}